import NavItem from "./navitem"
import LogoutButton from "./logoutButton"
import { GiHamburgerMenu } from "react-icons/gi";
import { useSiteContent } from "../contexts/siteContentContext";

import { useState, useRef, useEffect } from "react";

export default function NavBar() {
    const [topbarOpen, setTopbarOpen] = useState(false);
    const sidebarRef = useRef(null);
    const menuButton = useRef(null);
    const [user, setUser] = useState(null);
    const { getContent } = useSiteContent();

    useEffect(() => {
        const userData = localStorage.getItem("user");
        if (userData) {
            setUser(JSON.parse(userData));
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuButton.current && menuButton.current.contains(e.target)) {
                setTopbarOpen(prev => !prev);
                return;
            }
            if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
                setTopbarOpen(false);
            }
        }
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            document.removeEventListener("touchstart", handleClickOutside);
        }
    }, [topbarOpen])

    const navItems = (
        <>
            <NavItem href="/home">{getContent("nav.home", "Home")}</NavItem>
            <NavItem href="/home#about">{getContent("nav.about", "About")}</NavItem>
            <NavItem href="/home#services">{getContent("nav.services", "Services")}</NavItem>
            {(!user || user.role === "user") && (
                <NavItem href="/set-appointment">{getContent("nav.book", "Book Appointment")}</NavItem>
            )}
            {user && user.role === "user" && (
                <NavItem href="/my-appointments">{getContent("nav.appointments", "My Appointments")}</NavItem>
            )}
            {user && ["admin", "staff"].includes(user.role) && (
                <NavItem href="/admin-dashboard">{getContent("nav.dashboard", "Dashboard")}</NavItem>
            )}
            {user && user.role === "admin" && (
                <NavItem href="/cms">
                    <span className="bg-emerald-500/20 text-emerald-300 px-2 py-0.5 rounded-md text-sm font-semibold">{getContent("nav.cms", "CMS")}</span>
                </NavItem>
            )}
            {(!user || user.role === "user") && (
                <NavItem href="/home#contact">{getContent("nav.contact", "Contact")}</NavItem>
            )}
            {!localStorage.getItem("token") && (
                <NavItem href="/login">{getContent("nav.login", "Login")}</NavItem>
            )}
        </>
    );

    return (
        <>
        <nav>
            <ul className="hidden md:flex flex-row text-center gap-2 text-white">
                {navItems}
            </ul>
        </nav>

        <div className="md:hidden flex">
            <button ref={menuButton} className="z-50">
                <GiHamburgerMenu className="text-3xl z-30 text-white"/>
            </button>
        </div>
        <div ref={sidebarRef} className={`md:hidden drop-shadow-lg rounded-sm flex flex-col px-2 gap-1 py-2 min-h-[200%] z-[-3] bg-brand-primary w-full absolute top-[64px] right-0 shadow-lg transform transition-transform text-white duration-300 ease-in-out origin-top ${topbarOpen ? "scale-y-100 " : "scale-y-0"}`}>
            {navItems}
            {localStorage.getItem("token") && (
                <div className="px-4 py-2">
                    <LogoutButton showText={true} className="w-full justify-start" />
                </div>
            )}
        </div>
        </>
    )
}
